import React from "react";
import { Outlet } from "react-router-dom";

function SubLink(props) {

  return <Outlet/>;
}

export default SubLink;
